import { useEffect, useRef } from "react";
import { Link } from "react-router";
import { NAV_GROUPS } from "../../lib/nav.js";
import { SITE } from "../../lib/site.js";
import styles from "./MobileDrawer.module.css";

export default function MobileDrawer({ open, onClose }) {
  const panelRef = useRef(null);
  const closeRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const previous = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeRef.current?.focus();
    const onKey = (event) => {
      if (event.key === "Escape") onClose();
      if (event.key === "Tab" && panelRef.current) {
        const focusable = panelRef.current.querySelectorAll(
          'a[href], button, summary, [tabindex]:not([tabindex="-1"])'
        );
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          last.focus();
          event.preventDefault();
        } else if (!event.shiftKey && document.activeElement === last) {
          first.focus();
          event.preventDefault();
        }
      }
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = previousOverflow;
      previous?.focus?.();
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className={styles.backdrop}>
      {/* A real button (not a click handler on the static backdrop) closes the
          drawer on outside click, so it's independently keyboard-operable and
          never has to intercept clicks bubbling up from inside the panel. */}
      <button
        type="button"
        className={styles.backdropClose}
        aria-label="Close menu"
        onClick={onClose}
      />
      <div
        id="mobile-drawer"
        className={styles.panel}
        role="dialog"
        aria-modal="true"
        aria-label="Site menu"
        ref={panelRef}
      >
        <div className={styles.top}>
          <img
            src="/images/site/logo-white.png"
            alt="RDV Systems"
            width="210"
            height="32"
            className={styles.logo}
          />
          <button type="button" className={styles.close} onClick={onClose} ref={closeRef}>
            <span className="sr-only">Close menu</span>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <nav aria-label="Mobile">
          {NAV_GROUPS.map((group) => (
            <details key={group.label} className={styles.group}>
              <summary className={styles.summary}>{group.label}</summary>
              <ul className={styles.list}>
                {group.items.map((item) => (
                  <li key={item.href}>
                    <Link to={item.href} className={styles.link} onClick={onClose}>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </details>
          ))}
        </nav>
        <div className={styles.actions}>
          <Link to="/demo" className="btn btn-primary" onClick={onClose}>
            Request a Demo
          </Link>
          <a href={SITE.loginUrl} className="btn btn-secondary">
            Sign In
          </a>
          <a href={SITE.phoneHref} className={styles.contact}>
            {SITE.phone}
          </a>
          <a href={`mailto:${SITE.email}`} className={styles.contact}>
            {SITE.email}
          </a>
        </div>
      </div>
    </div>
  );
}
